import { Input } from "antd";
import React from "react";
const { TextArea } = Input;
export default function SalesComment({ value, setValue }) {
   const onChange = (e) => {
      setValue(e.target.value);
   };

   const style = { height: 100, marginBottom: 10 };

   return (
      <div>
         <TextArea defaultValue={value} style={style} onChange={onChange} />
      </div>
   );
}
